module.exports = __webpack_public_path__ + "img/profile-Selected-icon.6baca4bf.svg";